module.exports = __webpack_public_path__ + "img/gentlemen-club-carousel-30.a9768e8b.png";